import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { connectRefinementList } from 'react-instantsearch-dom'

const RefinementList = ({ label, attribute, items, refine }) => {
  const { messages } = useIntl()

  const ageGroupsAscending = [
    'Newborn',
    'Recién nacido',
    'Baby',
    'Bebé',
    'Toddler',
    'Niño pequeño',
    'Preschooler',
    'Niño en edad preescolar'
  ]

  let sortedItems = []
  if (attribute === 'ages.name') {
    sortedItems = items.sort(function (a, b) {
      if (ageGroupsAscending.indexOf(a.label) < ageGroupsAscending.indexOf(b.label)) {
        return -1
      } else {
        return 1
      }
    })
  } else {
    sortedItems = items.sort((a, b) => (a.label > b.label ? 1 : -1))
  }

  if (sortedItems.length > 0) {
    return (
      <div className='font-nunito font-semibold text-sm'>
        {sortedItems.map(item => (
          <div key={item.label} id={item.label.replace(/ /g, '-').toLowerCase()} className='mb-2'>
            <label className='inline-flex items-center'>
              <input
                type='checkbox'
                className='checkbox text-orange'
                checked={item.isRefined}
                onChange={() => refine(item.value)}
              />
              <div className='ml-2'>
                <span className='mr-2'>
                  {attribute === 'type' || attribute === 'activityType'
                    ? messages[item.label.replace(/\W/g, '').toLowerCase()]
                    : item.label}
                </span>
                <span className='tag-inline-inverted'>{item.count}</span>
              </div>
            </label>
          </div>
        ))}
      </div>
    )
  } else {
    return (
      <div className='font-nunito font-semibold text-sm'>
        <span>
          <FormattedMessage id='none' />
        </span>
      </div>
    )
  }
}

export default connectRefinementList(RefinementList)
